<div (click)="selectInfozone(b.infozone)" class="ion-padding">
  <img  *ngIf="!b.image && b.infozone" [src]="infozonethumbpath(b.infozone)" alt="">

  <div *ngIf="b.image" class="smtileitem-wrapper"
    [ngStyle]="{'background-image': 'url(' + safeURL(basepath+'storage/app/media'+b.image) + ')'}">
    <h1 class="title-button" expand="full">
      <ion-icon name="information-circle-sharp"></ion-icon>
    </h1>
  </div>
</div>